import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-appdownload',
  templateUrl: './mobile-appdownload.component.html',
  styleUrls: ['./mobile-appdownload.component.scss']
})
export class MobileAppdownloadComponent implements OnInit {
  QrUrl:any;
  constructor() {

 this.QrUrl ="https://play.google.com/store/apps/details?id=com.xsilica.paygfuturepos";
   }

  ngOnInit() {
  }

}
